/**
 * Generated from HudLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function HudLayout(this: $HudLayout) {
	$(this, "hud", hud, {x:1024, y:768});
	$(this, "mainWithTracker", mainWithTracker, {x:1024, y:768});
	$(this, "tracker", tracker, {x:1024, y:768});
	return this;
}
export function hud(this: $hud) {
	$(this, "buttonOk", buttonOk, {x:885.05, y:643.05, w:265.25, h: 260.65});
	$(this, "buttonHome", buttonHome, {x:-924.85, y:-541.15, w:194.00, h: 195.00});
	return this;
}
function buttonOk(this: $buttonOk) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-ok.png", 0.505, 0.506);
	return this;
}
function buttonHome(this: $buttonHome) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-home.png", 0.500, 0.500);
	return this;
}
function mainWithTracker(this: $mainWithTracker) {
	$(this, "buttonTracker", buttonTracker, {x:-878.8, y:632, w:263.00, h: 264.00});
	$(this, "buttonHome", buttonHome, {x:-816.15, y:-576.15, w:194.00, h: 195.00});
	return this;
}
function buttonTracker(this: $buttonTracker) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-tracker.png", 0.500, 0.500);
	return this;
}
export function tracker(this: $tracker) {
	$(this, "trackerModal", trackerModal, {x:0, y:0});
	return this;
}
function trackerModal(this: $trackerModal) {
	$(this, "background", trackerModalBg, {x:-547.15, y:-258.4, w:1114.00, h: 469.00});
	$(this, "progressBase", trackerProgressBar, {x:-481.8, y:-21.25, w:983.00, h: 45.00});
	$(this, "progressBar", trackerProgress, {x:-476.75, y:-15.25, w:970.00, h: 31.00});
	$(this, "packageDelivered", trackerPackage, {x:467.65, y:-3.95, w:119.00, h: 81.00});
	$(this, "flag", trackerFlag, {x:-492.1, y:-124.7, w:129.00, h: 90.00});
	$(this, "truck", trackerMailTruck, {x:-290.3, y:-4.5, w:203.00, h: 102.00});
	$(this, "buttonOk", buttonOk, {x:13.85, y:222.6, w:265.25, h: 260.65});
	$(this, "buttonClose", buttonClose, {x:-476, y:210.05, w:216.00, h: 216.00});
	return this;
}
function trackerModalBg(this: $trackerModalBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("tracker-modal.png", 0.000, 0.000);
	return this;
}
function trackerProgressBar(this: $trackerProgressBar) {
	if (this.setLayoutTexture) this.setLayoutTexture("tracker-progress-bar.png", 0.000, 0.000);
	return this;
}
function trackerProgress(this: $trackerProgress) {
	if (this.setLayoutTexture) this.setLayoutTexture("tracker-progress.png", 0.000, 0.000);
	return this;
}
function trackerPackage(this: $trackerPackage) {
	if (this.setLayoutTexture) this.setLayoutTexture("tracker-package.png", 0.504, 0.506);
	return this;
}
function trackerFlag(this: $trackerFlag) {
	if (this.setLayoutTexture) this.setLayoutTexture("tracker-flag.png", 0.000, 0.000);
	return this;
}
function trackerMailTruck(this: $trackerMailTruck) {
	if (this.setLayoutTexture) this.setLayoutTexture("tracker-mail-truck.png", 0.502, 0.500);
	return this;
}
function buttonClose(this: $buttonClose) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-close.png", 0.500, 0.500);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $HudLayout {
	readonly hud: $hud;
	readonly mainWithTracker: $mainWithTracker;
	readonly tracker: $tracker;
}
interface $hud extends $$container {
	readonly buttonOk: $buttonOk;
	readonly buttonHome: $buttonHome;
}
interface $buttonOk extends $$sprite {
}
interface $buttonHome extends $$sprite {
}
interface $mainWithTracker extends $$container {
	readonly buttonTracker: $buttonTracker;
	readonly buttonHome: $buttonHome;
}
interface $buttonTracker extends $$sprite {
}
interface $tracker extends $$container {
	readonly trackerModal: $trackerModal;
}
interface $trackerModal extends $$container {
	readonly background: $trackerModalBg;
	readonly progressBase: $trackerProgressBar;
	readonly progressBar: $trackerProgress;
	readonly packageDelivered: $trackerPackage;
	readonly flag: $trackerFlag;
	readonly truck: $trackerMailTruck;
	readonly buttonOk: $buttonOk;
	readonly buttonClose: $buttonClose;
}
interface $trackerModalBg extends $$sprite {
}
interface $trackerProgressBar extends $$sprite {
}
interface $trackerProgress extends $$sprite {
}
interface $trackerPackage extends $$sprite {
}
interface $trackerFlag extends $$sprite {
}
interface $trackerMailTruck extends $$sprite {
}
interface $buttonClose extends $$sprite {
}
